export default __webpack_public_path__ + "static/media/setting.f0b18ece.png";